module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ul', {
    staticClass: "nav nav-tabs"
  }, _vm._l((_vm.tabs), function(tab) {
    return _c('li', {
      key: tab,
      class: {
        active: tab === _vm.selectedTab
      },
      on: {
        "click": function($event) {
          return _vm.selectTab(tab)
        }
      }
    }, [_c('a', [_vm._v(" " + _vm._s(tab) + " ")])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "card",
    staticStyle: {
      "margin": "none"
    }
  }, [_c('div', {
    staticClass: "card-content"
  }, [_vm._t(_vm.selectedTab, function() {
    return [_vm._v("\n          Empty tab\n      ")]
  })], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-795a2c91!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UIComponents/Tabs.vue
// module id = 250
// module chunks = 3